import Joi from '@hapi/joi'

export const PluckingChecklistBPLTeaReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    pluckingType: Joi.string().invalid("0").required().label("PluckingType").messages({
        "any.invalid": `Please select valid plucking Type`,
        "any.required": `plucking Type required`
    }),
    date: Joi.string().invalid("").required().label("To Date"),
    checklistID: Joi.string().invalid("0").required().label("Checklist Number").messages({
        "any.invalid": `Please select valid plucking Type`,
        "any.required": `plucking Type required`
    })
}